// extracted by mini-css-extract-plugin
module.exports = {"formInputs":"styles_formInputs__N_qFB","link":"styles_link__2yilh index_caption__1AJ2W"};